var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inner-modal-close-button",on:{"click":_vm.clearModal}},[_c('div',{staticClass:"inner-modal-close-button__icon"}),_c('div',{staticClass:"inner-modal-close-button__text"},[_vm._v("Zamknij")])])
}
var staticRenderFns = []

export { render, staticRenderFns }